import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';

export const Container = styled.View``;

export const Label = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.medium};
`;

export const InputPicker = styled.View`
  height: ${RFValue(45)}px;
  border-style: solid;
  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.border};

  font-size: ${RFValue(12)}px;

  color: ${({theme}) => theme.colors.text_dark};
  font-family: ${({theme}) => theme.fonts.regular};
  flex-direction: row;
  align-items: center;
`;

export const PickerField = styled.View`
  flex: 1;
`;

export const IconPicker = styled(Feather)`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text_dark};
`;
